
export const environment = {
  production: true,
  name: 'prod',
  // Relativo de proposito: o front e sempre servido pelo mesmo host da API (em /jkawflex/),
  // e o Apache faz o proxy de /api para a API local. Com o host fixo aqui, o build de
  // producao instalado em QUALQUER cliente conversava com a API da InfoKaw -- e a tela lia
  // os dados do schema empresa1, com o container do cliente correto e sem erro nenhum.
  apiURL: '/api',
  siteKey: '6Lc48LYZAAAAAJk7qXiBpsfwgvVZUCghv7Ty9XoG',
  turnstileSiteKey: '0x4AAAAAABfFusTp47FQfJPP',
  // Conta identificada por e-mail: criar conta exige o código de 6 dígitos e criar/alterar
  // cadastro exige e-mail confirmado. Na API o par é usuario.email-confirmado.obrigatorio.
  exigeContaEmail: true,
  turnstileEnabled: true,
  mercadoPagoPublicKey: 'APP_USR-fde55cd8-3f63-4fd0-a3b5-90611ff640bb',
  mqtt: {
		server: 'infokaw.com.br',
		protocol: "wss",
		port: 8883,
    useSSL: true,
    path: "/mqtt",
    clientId: "SUPERVISORIO-HTTPS",
    username: 'api',
    password: '@9a03b933a5'
	}
};